module.exports = __webpack_public_path__ + "static/media/check_box.c74f4c50.svg";


//////////////////
// WEBPACK FOOTER
// /src/globals/images/check_box.svg
// module id = 1979
// module chunks = 0